var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreedots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_0_156)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2134,
    height: 44,
    rx: 22,
    transform: "matrix(1 0 0 -1 0 44)",
    fill: "#DCE4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9944 18.2663C22.5862 18.2786 22.1849 18.3874 21.8135 18.5864C21.442 18.7854 21.1076 19.0707 20.8294 19.4261C20.5512 19.7816 20.3347 20.2001 20.1921 20.6578C20.0496 21.1155 19.9838 21.6034 19.9986 22.0937C20.0134 22.584 20.1084 23.0671 20.2783 23.5154C20.4482 23.9637 20.6896 24.3684 20.9887 24.7064C21.2878 25.0444 21.6387 25.3091 22.0215 25.4853C22.4043 25.6616 22.8114 25.746 23.2196 25.7337C24.044 25.7086 24.8227 25.2912 25.3844 24.5732C25.9461 23.8553 26.2448 22.8957 26.2147 21.9054C26.1847 20.9152 25.8284 19.9755 25.2242 19.293C24.62 18.6106 23.8174 18.2412 22.993 18.2663L22.9944 18.2663ZM13.1084 18.5644C12.7002 18.5767 12.2989 18.6855 11.9275 18.8845C11.556 19.0835 11.2216 19.3689 10.9434 19.7243C10.6652 20.0797 10.4487 20.4982 10.3061 20.9559C10.1636 21.4136 10.0978 21.9015 10.1126 22.3918C10.1274 22.8822 10.2224 23.3653 10.3923 23.8135C10.5622 24.2618 10.8035 24.6665 11.1026 25.0045C11.4018 25.3425 11.7527 25.6072 12.1355 25.7835C12.5183 25.9597 12.9254 26.0441 13.3336 26.0318C14.158 26.0067 14.9367 25.5893 15.4984 24.8714C16.0601 24.1534 16.3588 23.1938 16.3287 22.2035C16.2987 21.2133 15.9424 20.2736 15.3382 19.5911C14.734 18.9087 13.9314 18.5394 13.107 18.5644L13.1084 18.5644ZM32.8804 17.9682C32.4722 17.9805 32.0709 18.0892 31.6995 18.2882C31.328 18.4873 30.9936 18.7726 30.7154 19.128C30.4372 19.4834 30.2207 19.9019 30.0781 20.3596C29.9356 20.8173 29.8698 21.3053 29.8846 21.7956C29.8994 22.2859 29.9944 22.769 30.1643 23.2173C30.3342 23.6656 30.5756 24.0703 30.8747 24.4083C31.1738 24.7463 31.5247 25.011 31.9075 25.1872C32.2903 25.3635 32.6974 25.4479 33.1056 25.4356C33.93 25.4105 34.7087 24.9931 35.2704 24.2751C35.8321 23.5572 36.1308 22.5975 36.1008 21.6073C36.0707 20.6171 35.7144 19.6774 35.1102 18.9949C34.506 18.3124 33.7034 17.9431 32.879 17.9682L32.8804 17.9682Z",
    fill: "#3B4F7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_0_156",
    x: -2,
    y: -2,
    width: 50.2134,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729167 0 0 0 0 0.763889 0 0 0 0 0.875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_0_156",
    result: "effect2_innerShadow_0_156"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.d682b554d8c047c846943f973caa1ace.svg";
export { ForwardRef as ReactComponent };